module.exports = __webpack_public_path__ + "img/imago.0002107.svg";